<script setup>
import {defineProps, defineEmits, computed} from 'vue'

const props = defineProps({
  icon: {
    type: String,
    default: ''
  },
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:icon', 'update:title', 'update:description'])

const icon = computed({
  get: () => props.icon,
  set: (value) => {
    emit('update:icon', value)
  }
})

const title = computed({
  get: () => props.title,
  set: (value) => {
    emit('update:title', value)
  }
})

const description = computed({
  get: () => props.description,
  set: (value) => {
    emit('update:description', value)
  }
})


</script>

<template>

  <div class="child">
    <v-btn :icon="icon" color="red" class="text-white"></v-btn>
    <h1>{{ title }}</h1>
    <p class="text-grey ml-3 mt-4 text-caption">
      {{ description }}
    </p>
  </div>
</template>

<style scoped lang="scss">

</style>
